import styled, { css } from "styled-components";
import { units } from "@m/alchemy-theme";
import { Button } from "../button/Button";
import { ButtonGroup } from "../button-group/ButtonGroup";
import { ButtonGroup as StyledButtonGroup } from "../button-group/ButtonGroup.styled";
const END_CAP_OFFSET = 3;
const BUTTON_GROUP_OFFSET = 0.5;
/* Need styled component here so we can spread props on it without an error */
export const DialogFooter = styled.div `
  display: block;
  text-align: ${({ isCentered }) => (isCentered ? "center" : "inherit")};
  padding: ${units(0.5)} 0 0;

  ${StyledButtonGroup} {
    margin-bottom: -${units(BUTTON_GROUP_OFFSET)};
  }

  ${({ buttonLayout }) => buttonLayout === "endcap" &&
    css `
      margin: -${units(END_CAP_OFFSET)};
      margin-top: 0;
      padding: 0;
      margin-bottom: -${units(END_CAP_OFFSET - BUTTON_GROUP_OFFSET)};

      button:first-child {
        border-bottom-left-radius: ${units(2)};
      }
      button:last-child {
        border-bottom-right-radius: ${units(2)};
      }
    `};
`;
export const DialogFooterButtonGroup = styled(ButtonGroup) `
  display: flex;
  align-items: center;
  justify-content: ${({ isCentered }) => (isCentered ? "center" : "flex-end")};
  margin-bottom: -${units(BUTTON_GROUP_OFFSET)};
`;
export const DialogFooterButton = styled(Button) `
  width: ${({ isFullWidth }) => (isFullWidth ? "100%" : "auto")};

  &:not(:last-child) {
    margin-right: ${units(1.5)};
  }
`;
